import { Chain } from '@1delta/chain-registry'
import { Lender } from '@1delta/lender-registry'
import { compoundV3BaseData, compoundV3Pools } from '@1delta/data-sdk'

export function getCompoundV3CometAddress(
  chainId: string,
  lender: string = Lender.COMPOUND_V3_USDCE,
): string | undefined {
  return compoundV3Pools()?.[chainId]?.[lender]
}

export function getCompoundV3CometRewardsAddress(chainId: string) {
  // @ts-ignore
  return addressesCompoundV3.cometRewards[chainId]
}

export function getCompoundV3CometLens(chainId: string) {
  // @ts-ignore
  return addressesCompoundV3.lens[chainId]
}

const addressesCompoundV3 = {
  lens: {
    [Chain.POLYGON_MAINNET]: '0x4eDA401658c5286d16c4d342884F32280B4E8b1b',
    [Chain.MANTLE]: '0x32B31A066c8dd3F7b77283Ba1d89Ddaf6DA0a8aE',
    [Chain.ARBITRUM_ONE]: '0x13D9c35f4901491Ac4FFebd3100238BBfFBD7181',
    [Chain.BASE]: '0x7e2D250E4FD0EeD6BD2cB3DC525A2b9f12508152',
    [Chain.OP_MAINNET]: '0xA453ba397c61B0c292EA3959A858821145B2707F',
    [Chain.ETHEREUM_MAINNET]: '0xCe434378adacC51d54312c872113D687Ac19B516',
    [Chain.UNICHAIN]: '0x0bd7473CbBf81d9dD936c61117eD230d95006CA2',
    [Chain.LINEA]: '0x7a59ddbB76521E8982Fa3A08598C9a83b14A6C07',
    [Chain.SCROLL]: '0x32198Ee619fAd24169fa94A149Cb5205701C6AB1',
    [Chain.PLASMA_MAINNET]: '0x0bd7473CbBf81d9dD936c61117eD230d95006CA2',
    [Chain.RONIN_MAINNET]: '0x0bd7473CbBf81d9dD936c61117eD230d95006CA2',
  },
  cometRewards: {
    [Chain.POLYGON_MAINNET]: '0x45939657d1CA34A8FA39A924B71D28Fe8431e581',
    [Chain.MANTLE]: '0xCd83CbBFCE149d141A5171C3D6a0F0fCCeE225Ab',
    [Chain.ARBITRUM_ONE]: '0x88730d254A2f7e6AC8388c3198aFd694bA9f7fae',
    [Chain.BASE]: '0x123964802e6ABabBE1Bc9547D72Ef1B69B00A6b1',
    [Chain.OP_MAINNET]: '0x443EA0340cb75a160F31A440722dec7b5bc3C2E9',
    [Chain.ETHEREUM_MAINNET]: '0x1B0e765F6224C21223AeA2af16c1C46E38885a40',
    [Chain.SCROLL]: '0x70167D30964cbFDc315ECAe02441Af747bE0c5Ee',
    [Chain.LINEA]: '0x2c7118c4C88B9841FCF839074c26Ae8f035f2921',
    [Chain.UNICHAIN]: '0x6f7D514bbD4aFf3BcD1140B7344b32f063dEe486',
    // Compound's own `deployments/ronin/{weth,wron}/roots.json`, code-checked
    // 2026-09-16 (lens deployed the same day, 5204 bytes).
    [Chain.RONIN_MAINNET]: '0x31CdEe8609Bc15fD33cc525f101B70a81b2B1E59',
  },
}

export function getCompoundV3BaseAsset(lender: string, chainId: string) {
  return compoundV3BaseData()?.[lender]?.[chainId]
}
